import { useState } from 'react'
import { ArrowLeft, CheckCircle2, Loader2, LockKeyhole, ShieldCheck, X } from 'lucide-react'
import { useAuth } from '../context/AuthContext'
import type { Language } from '../types'

export function LoginModal({ language, open, onClose }: { language: Language; open: boolean; onClose: () => void }) {
  const en = language === 'en'
  const { user, otpSent, sendOtp, verifyOtp, logout, resetOtp } = useAuth()
  const [phone, setPhone] = useState('')
  const [otp, setOtp] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  if (!open) return null

  const run = async (action: () => Promise<void>) => {
    setBusy(true); setError('')
    try { await action() } catch (err) { setError(err instanceof Error ? err.message : 'कुछ गलत हुआ।') } finally { setBusy(false) }
  }

  return <div className="modal-backdrop" onMouseDown={(e) => e.target === e.currentTarget && onClose()}>
    <section className="auth-modal" role="dialog" aria-modal="true">
      <button className="modal-close" onClick={onClose}><X /></button>
      <div className="auth-emblem"><LockKeyhole /></div>
      {user ? <>
        <CheckCircle2 className="success-icon" size={44} />
        <h2>{en ? 'You are logged in' : 'आप लॉगिन हैं'}</h2>
        <p>{user.phoneNumber}</p>
        <button className="primary-button full" onClick={onClose}>{en ? 'Continue' : 'आगे बढ़ें'}</button>
        <button className="text-button" onClick={() => run(logout)}>Logout</button>
      </> : <>
        <p className="eyebrow">SECURE LOGIN</p>
        <h2>{otpSent ? (en ? 'Enter OTP' : 'OTP दर्ज करें') : (en ? 'Welcome to Mokshm' : 'Mokshm में आपका स्वागत है')}</h2>
        <p className="muted">{otpSent ? (en ? `Enter the 6-digit OTP sent to ${phone}.` : `${phone} पर भेजा गया 6 अंकों का OTP डालें।`) : (en ? 'Verify your mobile number for bookings and consultations.' : 'Booking और consultation के लिए mobile number verify करें।')}</p>
        {!otpSent ? <>
          <label className="field-label">{en ? 'Mobile number' : 'मोबाइल नंबर'}</label>
          <div className="phone-field"><span>+91</span><input value={phone} onChange={(e) => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))} inputMode="numeric" placeholder="98765 43210" /></div>
          <button className="primary-button full" disabled={phone.length !== 10 || busy} onClick={() => run(() => sendOtp(phone))}>{busy ? <Loader2 className="spin" /> : en ? 'Send OTP' : 'OTP भेजें'}</button>
        </> : <>
          <input className="otp-input" value={otp} onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))} inputMode="numeric" placeholder="• • • • • •" autoFocus />
          <button className="primary-button full" disabled={otp.length !== 6 || busy} onClick={() => run(async () => { await verifyOtp(otp); onClose() })}>{busy ? <Loader2 className="spin" /> : en ? 'Verify OTP' : 'OTP Verify करें'}</button>
          <button className="text-button" onClick={() => { resetOtp(); setOtp('') }}><ArrowLeft size={15} /> {en ? 'Change number' : 'नंबर बदलें'}</button>
        </>}
        {error && <div className="form-error">{error}</div>}
        <div id="recaptcha-container" />
        <div className="privacy-line"><ShieldCheck size={16} /> {en ? 'Your number remains secure and is never shared without permission.' : 'आपका नंबर सुरक्षित रहेगा और बिना अनुमति साझा नहीं होगा।'}</div>
      </>}
    </section>
  </div>
}
